document.addEventListener('DOMContentLoaded', function () {
  const images = document.querySelectorAll('.carousel-image');
  const indicators = document.querySelectorAll('.indicator');
  let currentIndex = 0;
  let interval;

  // Función para mostrar la imagen activa
  function showImage(index) {
    images.forEach((image, i) => {
      image.classList.toggle('active', i === index);
    });
    // Actualiza las pestañitas
    indicators.forEach((indicator, i) => {
      indicator.classList.toggle('active', i === index);
    });
  }

  // Función para cambiar manualmente mediante las pestañitas
  function setActiveImage(index) {
    currentIndex = index;
    showImage(currentIndex);
    resetInterval(); // Reiniciar el contador cuando se selecciona manualmente
  }

  // Función para reiniciar el contador del carrusel
  function resetInterval() {
    clearInterval(interval); // Detener el contador actual
    interval = setInterval(() => {
      currentIndex = (currentIndex + 1) % images.length;
      showImage(currentIndex);
    }, 10000); // Reiniciar el contador a 10 segundos
  }

  // Cambio automático cada 10 segundos
  resetInterval(); // Iniciar el contador automáticamente cuando la página carga

  // Inicializar la primera imagen como activa
  showImage(currentIndex);

  // Asignar eventos a las pestañitas
  indicators.forEach((indicator, index) => {
    indicator.addEventListener('click', () => setActiveImage(index));
  });
});
























